import { Stack, styled } from '@mui/material'

/** The band a table's toolbar sits in, above the column headers. Shared so every table reads as one. */
export const ToolbarSurface = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.bg.surface.default,
  borderBottomStyle: 'solid',
  borderBottomWidth: theme.strokeWidth.default,
  borderBottomColor: theme.palette.border.strong,
}))
